import './CustomReport.less';
import React from 'react';
import useGetCurrentCustomReport from '../hooks/useGetCurrentCustomReport';
import { Col, Row } from 'antd';
import CustomReportForm from './CustomReportForm';
import TemplateReport from '../template/TemplateReport';

export default function CustomReport() {
    const { currentTemplate, templateGuid, reportGuid, reportUrl, setCustomReport } = useGetCurrentCustomReport();

    return (
        <Row
            gutter={[16, 16]}
            className="custom-report-templates"
        >
            <Col
                span={12}
                className="form-col"
            >
                <CustomReportForm
                    templateGuid={templateGuid}
                    reportGuid={reportGuid}
                    reportUrl={reportUrl}
                    onReportChange={setCustomReport}
                />
            </Col>
            <Col
                span={12}
                className="preview-col"
            >
                {currentTemplate && (
                    <TemplateReport
                        templateGuid={templateGuid}
                        reportGuid={reportGuid}
                        reportUrl={reportUrl}
                        logo={currentTemplate.logo}
                        header={currentTemplate.content_blocks.header}
                        footer={currentTemplate.content_blocks.footer}
                    />
                )}
            </Col>
        </Row>
    );
}
